import { ref } from 'vue';
import { defineStore } from 'pinia';

export const useGroupFilterStore = defineStore('groupFilter', () => {
  const groupIds = ref<number[]>([]);

  function clear() {
    groupIds.value = [];
  }

  return { groupIds, clear };
}, { persist: true });
